// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"eO","imgTextCardBox":"eO","text-box":"eP","textBox":"eP","remark-val":"eQ","remarkVal":"eQ"};